module.exports = __webpack_public_path__ + "static/media/eventsM.5bd5547c.jpg";